// extracted by mini-css-extract-plugin
export default {"soundToggle":"SoundToggle_soundToggle__2p8pR"};